import ProductCorpusAPI from '../../../../javascript/dashboard/api/productcorpus';

const state = () => ({
  corpusId: null,
  products: [],
  isLoading: false,
  error: null,
});

const getters = {
  getProductCorpora: s => s.products,
  getProductCorpusId: s => s.corpusId,
  getProductCount: s => s.products.length,
  isProductBusy: s => s.isLoading,
  getProductError: s => s.error,
};

const mutations = {
  SET_LOADING(s, v) { s.isLoading = v; },
  SET_ERROR(s, msg) { s.error = msg; },
  SET_CORPUS_ID(s, id) { s.corpusId = id; },
  SET_PRODUCTS(s, list) { s.products = list || []; },
  UPSERT_PRODUCTS(s, list) {
    const map = new Map(s.products.map(p => [p.id, p]));
    list.forEach(p => map.set(p.id, p));
    s.products = Array.from(map.values());
  },
  REMOVE_PRODUCTS(s, ids) {
    const set = new Set(ids);
    s.products = s.products.filter(p => !set.has(p.id));
  },
  RESET(s) {
    s.corpusId = null;
    s.products = [];
    s.error = null;
    s.isLoading = false;
  },
};

const actions = {
  async ensureBotExists() {
    try {
      await axios.post('/botify/bots', {});
    } catch (e) {
      const status = e?.response?.status;
      if (status !== 409) throw e;
    }
  },

  async addMany({ commit }, items) {
    commit('SET_LOADING', true); commit('SET_ERROR', null);
    try {
      await this.dispatch('botifyProduct/ensureBotExists');
      const res = await ProductCorpusAPI.addProducts(items);
      commit('SET_CORPUS_ID', res?.data?.data?.corpusId || null);
      commit('UPSERT_PRODUCTS', res?.data?.data?.products || []);
      return res;
    } catch (e) {
      commit('SET_ERROR', e?.response?.data?.message || e.message || 'Failed to add products');
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateMany({ commit }, items) {
    commit('SET_LOADING', true); commit('SET_ERROR', null);
    try {
      const res = await ProductCorpusAPI.updateProducts(items);
      commit('SET_CORPUS_ID', res?.data?.data?.corpusId || null);
      commit('UPSERT_PRODUCTS', res?.data?.data?.products || []);
      return res;
    } catch (e) {
      commit('SET_ERROR', e?.response?.data?.message || e.message || 'Failed to update products');
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteMany({ state, commit }, ids) {
    commit('SET_LOADING', true); commit('SET_ERROR', null);
    try {
      const res = await ProductCorpusAPI.deleteProducts(ids);
      commit('REMOVE_PRODUCTS', ids);
      if (state.products.length === 0) commit('SET_CORPUS_ID', null);
      return res;
    } catch (e) {
      commit('SET_ERROR', e?.response?.data?.message || e.message || 'Failed to delete products');
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
